export var ContentType;
(function (ContentType) {
    ContentType[ContentType["Dashboard"] = 0] = "Dashboard";
    ContentType[ContentType["Explore"] = 1] = "Explore";
    ContentType[ContentType["ServiceMap"] = 2] = "ServiceMap";
})(ContentType || (ContentType = {}));
export class ApmEntity {
    id;
    name;
    url;
    type;
    createdBy;
    editedBy;
    editedAt;
    detector;
    tabs;
}
//# sourceMappingURL=apm-entity.js.map